var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9681 0.5C14.1982 0.5 15.206 1.45186 15.295 2.65919L15.3014 2.83333V21.5H8.30143V2.83333C8.30143 1.60324 9.25329 0.595474 10.4606 0.5064L10.6348 0.5H12.9681ZM21.1348 6.33333C22.4235 6.33333 23.4681 7.378 23.4681 8.66667V19.1667C23.4681 20.4554 22.4235 21.5 21.1348 21.5H17.6348V6.33333H21.1348ZM5.9681 9.83333V21.5H2.4681C1.17943 21.5 0.134766 20.4554 0.134766 19.1667V12.1667C0.134766 10.878 1.17943 9.83333 2.4681 9.83333H5.9681Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.1177f9ceda62353bf896a6103853e2c7.svg";
export { ForwardRef as ReactComponent };